import { Button, Flex, Icon, Tooltip, useStyleConfig } from '@chakra-ui/react';
import { RiDeleteBinFill, RiEditFill } from 'react-icons/ri';
import { handleRemove } from '../../../handlers';
import { handleEditable } from './utils.js';
const SummaryNav = ({ props, secOrIndIndex }) => {
  const variant = 'wrapper';
  const buttonStyles = useStyleConfig('Button', { variant });
  return (
    <Flex flexDirection={['column', null, 'row']} justifyContent="flex-end">
      <Tooltip
        label="edit"
        placement='top'
        hasArrow
        bg="GRAY"
        color="WHITE"
        fontWeight={600}
        borderRadius={99}
      >
        <Button
          sx={{...buttonStyles.tertiary,...buttonStyles.sumNav}}
          onClick={e => {
            handleEditable(props.stateProps, secOrIndIndex);
          }}
        >
          <Icon as={RiEditFill} sx={{ color: 'GRAY_2' }} />
        </Button>
      </Tooltip>
      <Tooltip
        label="discard"
        placement='top'
        hasArrow
        bg="GRAY"
        color="WHITE"
        fontWeight={600}
        borderRadius={99}
      >
        <Button
          sx={{...buttonStyles.tertiary,...buttonStyles.sumNav}}
          onClick={e => {
            handleRemove(props.formikProps, props.stateProps, secOrIndIndex);
          }}
        >
          <Icon as={RiDeleteBinFill} sx={{ color: 'GRAY_2' }} />
        </Button>
      </Tooltip>
    </Flex>
  );
};

export default SummaryNav;
